<template>
  <div class="tabmenudemo-content">
    <div v-if="!patient" class="no-patient">
      <p>No patient selected</p>
    </div>
    <div v-if="!upcomingOrPendingSessionsData?.length && patient">
      <TumorBoardNewSession />
    </div>
    <div v-else>
      <div v-for="(patient) in upcomingOrPendingSessionsData" :key="patient.mrn" class="container-div">
        <div>
          <span class="date-span">{{ patient.date ? formatDate(patient.date) : "Pending" }}</span>
        </div>
        <div>
          <span class="tumor-board-span">{{ `${patient.tb_name} Tumor Board Meeting` }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// Copyright (c) 2020-2023 Omics Data Automation, Inc.
// Copyright (c) 2023 datma, inc.
//
// Proprietary and Confidential:
// Unauthorized copying of this file by any medium is strictly prohibited.
import { computed, ref, watch } from 'vue'
import { useStore } from 'vuex'
import TumorBoardNewSession from './TumorBoardNewSession.vue'
import { getTumorBoardSessionsData } from './getTumorBoardSessionsData'
import { formatDate } from '@/utils/utils.js'

const store = useStore()
const upcomingOrPendingSessionsData = ref([])
const patient = computed(() => store.getters.session.patient)

watch(patient, async (newPatient) => {
  if (!newPatient) { return }
  const tumorBoardSessionsData = await getTumorBoardSessionsData(patient.value.id)
  store.dispatch('setTumorBoardSessionsData', { tumorBoardSessionsData, publish: true })
  const upcomingOrPendingSessions = tumorBoardSessionsData.Upcoming?.length ? tumorBoardSessionsData.Upcoming : tumorBoardSessionsData.Pending
  upcomingOrPendingSessionsData.value = upcomingOrPendingSessions?.map(item => ({ ...item, mrn: patient.value.id }))
}, { immediate: true })

</script>

<style scoped>
.tabmenudemo-content {
  text-align: center;
}

.container-div {
  text-align: left;
}

.date-span {
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: var(--Grey500);
}

.tumor-board-span {
  font-size: 14px;
  font-weight: 400;
  line-height: 16.41px;
  letter-spacing: -0.32px;
  color: var(--Grey800);
}

.container-div {
  margin-bottom: 10%;
}

.no-patient {
  color: var(--Grey600);
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 200px;
}
</style>
